<template>
	<div>
		<div class="container-fluid my-account">
			<div class="row">
				<div class="col-md-12 page_title">Credits</div>
			</div>
			<div class="row">
				<div class="col-md-12">
					<div
						class="success_message"
						v-text="this.$root.success_message"
						v-if="this.$root.success_message != ''"
					></div>
					<div
						class="error_message"
						v-text="this.$root.error_message"
						v-if="this.$root.error_message != ''"
					></div>
				</div>
				<div class="col-md-2 account_sidebar">
					<ul class="sidebar">
						<li class="sidebar_list active">
							<router-link :to="{ name: 'dashboard' }">OverView</router-link>
						</li>
						<li class="sidebar_list">
							<h4 class="sidebar_heading">Orders & returns</h4>
							<router-link :to="{ name: 'order' }">My Orders</router-link>
						</li>
						<li class="sidebar_list">
							<h4 class="sidebar_heading">Account</h4>
							<router-link :to="{ name: 'address_book' }">Profile</router-link>
							<!-- <router-link :to="{name:'address_book'}">Saved Cards</router-link> -->
							<router-link :to="{ name: 'address_book' }">Address</router-link>
						</li>
                        <li class="sidebar_list">
							<h4 class="sidebar_heading">Credits</h4>
							<router-link :to="{ name: 'StoreCredit' }">WNDW Credits</router-link>
						</li>
					</ul>
				</div>

				<div class="col-md-10 storeCredit bg-white mt-5">
					<div class="row">
                        <div class="col-md-12">
                            <div class="card mb-4 text-center p-5"> 
                                <img src="img/creditIcon.png" class="m-auto img-fluid mb-2" style="height:60px"/>
                                <p style="font-family:lhmSemibold;text-transform: uppercase; font-size:11px; color:#999; margin:0;margin-top: 10px;">A quick and convenient way to pay and refund </p>
                            </div>
						</div>	
						<div class="col-md-12 mb-4">
                            <div class="card text-center p-5">
								<p style="font-family:lhmSemibold;text-transform: uppercase; font-size: var(--font-size-regular); margin: 0;">Your Wallet Balance</p>
								<p style="font-size: 30px; margin: 0; font-weight:bold"> <span> ₹ </span> {{this.$root.storeCredit}}</p>
                            </div>
						</div>
						<div class="col-md-12 mb-4" v-if="this.$root.outTandingBalance>0">
                            <div class="card text-center p-5" style="box-shadow: 2px 2px 4px 1px #ccc;">
								<p style="font-family:lhmSemibold;text-transform: uppercase; font-size: var(--font-size-regular); margin: 0;">Your Out Standing Balance</p>
								<p style="font-size: 30px; margin: 0; font-weight:bold"> <span> ₹ </span> {{this.$root.outTandingBalance}}</p>
                            </div>
						</div>
						<div v-if="getTransactionlog.length" class="col-md-12 mb-4">
							<div class="card text-left">
								<div class="creditHeader p-2 border-bottom">
									<h4 class="p-1">Transaction Log</h4>
								</div>
				
								<div  v-for="(item , index) in getTransactionlog" :key="index" >
									<div v-if="index < showData" class="creditDetail text-left p-2 border-bottom">
										<p class="m-0">
										<span style="text-transform: capitalize;">{{item.type.replace("_", " ")}}</span>
										<span class="float-right">
											{{item.created_at}}
										</span>	
										</p>
										<p class="credtiOrder m-0">
										<span>	Order No: {{item.order_increment_id == null ? " ": item.order_increment_id}}</span>
											<span class="float-right "  :class="[item.amount_credit.charAt(0) == '-' ? 'text-danger' : 'text-success']">
												{{item.amount_credit}}
											</span>
										</p>
									</div>
								</div>
						
								<div class="creditDetail text-center p-2 border-bottom">
									<p class="text-logo-color mb-0" style="cursor:pointer" @click="showAllData"  v-if="isViewMore">Show More</p>
									<p class="text-logo-color mb-0" style="cursor:pointer" @click="hideAllData" v-if="isViewMore == false" >Hide  </p>
								</div>
							</div>
						</div>

						<div class="col-md-12 mb-4">
							<div class="card text-left">
								<div class="creditHeader p-2 border-bottom">
									<h4>PLEASE NOTE</h4>
								</div>
								<div class="creditDetail text-left p-2 border-bottom">
									<ul>
										<li>WNDW Credit can't be cancelled or transferred to another account.</li>
										<li>It can't be withdrawn in the form of cash or transferred to any bank account.</li>
										<li>It can't be used to purchase Gift Cards.</li>
										<li>Net-banking and credit/debit cards issued in India can be used for WNDW Credit top up.</li>
										<li>Credits have an expiry. Check FAQs for more details.</li> 
									</ul>
								</div>
								 
							</div>
						</div>						


					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
	.creditHeader h4{
		font-size:  var(--font-size-heading);
		text-transform: uppercase;
		padding: 10px 0;
		margin: 0;
		font-family: 'lhmBold';
	}
	.creditDetail{
		font-family: 'lhmSemiBold';
	}
	.creditDetail p{
		font-size: 14px;
	}
	.credtiOrder{
		color: #757575;
	}
	.creditDetail span{
		font-family: 'lhmBold';
	}
	.creditDetail:last-child{
		/* border-bottom: none !important; */
	}
	.creditDetail ul{
		padding: 0 20px;
	}
	.creditDetail ul li{
		font-size: 14px;
		padding: 2px 0;
		color: grey;
	}
</style>

<script>
import axios from 'axios';
export default {
	name :  " ",
	 metaInfo: {
      title: 'WNDW Credits'
	},
	
	data(){
		return {
		getTransactionlog : [],
		showData : 10,
		isViewMore : true
		}
	},
	methods : {
		getCreditslog(){ 
			const fd = new FormData
			fd.append('customer_id', this.$root.customer_id)
			fd.append('customer_session', this.$root.customer_session)
			axios.post(`${this.$root.cart_api}/customer/credits-log`, fd)
			.then(response => {
			  if(response.data.success === true){
				//   console.log("data", response.data.data);
				  this.getTransactionlog = response.data.data;
			  }
			})
			.catch((error) => {
				console.log(error)
			})
		},
		showAllData(){
			this.showData = this.getTransactionlog.length;
			this.isViewMore = 	!this.isViewMore;
		},
		hideAllData(){
			this.showData = 10;
			this.isViewMore = 	true;
		}

	},
	mounted(){
		this.getCreditslog();
	}


}
</script>